// extracted by mini-css-extract-plugin
export default {"header":"FeaturedRaces_header__Gfbfv","contentContainer":"FeaturedRaces_contentContainer__yTb-7","fullWidth":"FeaturedRaces_fullWidth__PqBWJ"};